<app-loader></app-loader>
<app-header-page-spdji style="position: fixed; width: 100%; z-index: 10"></app-header-page-spdji>
<app-health-check *ngIf="healthCheck" style="position: relative; top: 100px; left: 100px"></app-health-check>
<app-iboxx-side-bar *ngIf="!downloadPage && !healthCheck" [clickedOutside]="isClicked" (headlineIndices)="getHeadlineIndices($event)"
                    (s3ContentsLoaded)="hasS3ContentsLoaded($event)" (EMIXIndices)="getEMIXIndices($event)"></app-iboxx-side-bar>
<div style="padding-left: 60px;" (click)="clickedOutside()" *ngIf="(headlineIndices && s3ContentsLoaded) || downloadPage">
  <router-outlet></router-outlet>
</div>

<footer class="systemInfoContainer">
  <div class="emixIndicesSystemInfo">
    Indices Website (version: <span> {{siteVersion}}</span>).
    Copyright © {{currentYear}} S&P Global. ALL DATA PROVIDED AS IS, WITH NO WARRANTIES. All rights reserved.
  </div>
</footer>
<app-footer-page-spdji></app-footer-page-spdji>
